/*
 * @Author: lixinxin lixinxin@huan.tv
 * @Date: 2023-01-05 16:13:28
 * @LastEditors: 文件最后更新人：任亮
 * @LastEditTime: 2025-08-22 17:46:10
 * @FilePath: \operation-web\src\utils\index.ts
 * @Description:
 *
 * Copyright (c) 2023 by ${git_name_email}, All Rights Reserved.
 */
/**
 * 此工具类 为了方便以后使用，只写一次，整体项目如有需要 所有工具或简化函数添加此处
 * 用处：将融合进loadsh 和 自定义函数导出新的loadsh 对象以供使用
 */
import { cloneDeep, isEqual, merge } from "lodash";
import JSEncrypt from "jsencrypt";
const encryptor = new JSEncrypt();
import { h } from "vue";
import { NDropdown, NButton, NIcon } from "naive-ui";
import { MoreVertical16Regular } from "@vicons/fluent";
import Big from "big.js";
import { saveAs } from "file-saver";

let isCopy;
/**
 * 是否为null字符的判断
 * return true 正确不等于空 false 空
 */
const isNullCheck = (value: any) => {
  if (value == null && value == undefined && value == "") {
    return false;
  }
  return true;
};

const setLocalData = (name = "", value = "") => {
  localStorage.setItem(name, JSON.stringify(value));
};

const getLocalData = (name = "") => {
  return localStorage.getItem(name)
    ? JSON.parse(<string>localStorage.getItem(name))
    : "";
};

const getAsyncReader = (reader: { onload: (e: any) => void; onerror: () => void; }) => {
  return new Promise((resolve, reject) => {
    reader.onload = (e: any) => {
      resolve(e);
    };
    reader.onerror = () => reject();
  });
}

/**
 * 下载文件专用函数
 * @param url 下载地址
 * @param name  生成的文件名 需要携带文件类型后缀
 */
const downLoadFile = (data, name = "文件", type = "url") => {
  try {
    let url = type == "url" ? data : "";
    let blob;
    if (type == "blob") {
      blob = new Blob([data]);
      let urls = URL || webkitURL;
      url = urls.createObjectURL(blob);
    }
    if (navigator.msSaveOrOpenBlob) {
      //ie edge 兼容
      navigator.msSaveOrOpenBlob(blob, name);
      return;
    }
    const a = document.createElement("a"); // 创建a标签
    a.setAttribute("download", name); // download属性
    a.setAttribute("href", url); // href链接
    a.click(); // 自执行点击事件
  } catch (e) {
    console.log("下载失败");
  }
};
// 文件流下载
const downBlobFile = (data: any, fileName?: any) => {
  const finalFileName = fileName || "模版.xlsx";
  console.error("data", data);
  if (data.type && data.type.indexOf("application/json") > -1) {
    // 说明是普通对象数据，后台转换失败
    const fileReader = new FileReader();
    fileReader.readAsText(data, "utf-8");
    fileReader.onloadend = function () {
      let dataJson = JSON.parse(fileReader.result);
      window.$message.error(dataJson.message);
    };
  } else {
    console.log("444");
    const blob = new Blob([data], {
      type: "application/zip",
    });
    saveAs(blob, finalFileName);
  }
};
const DownLoadBlobFile = (res: any, fileName = "模板.xlsx") => {
  let blob = new Blob([res], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8",
  });
  const elink = document.createElement("a");
  if ("download" in elink) {
    // 非IE下载
    if (fileName != "") {
      elink.download = fileName;
    }
    elink.style.display = "none";
    elink.href = URL.createObjectURL(blob);
    document.body.appendChild(elink);
    elink.click();
    URL.revokeObjectURL(elink.href); // 释放URL 对象
    document.body.removeChild(elink);
  }
};
/**
 * 批量下载文件专用函数
 * @param fileUrls 下载地址数组
 */
const downloadFiles = (fileUrls: any) => {
  let index = 0;
  const downloadNext = () => {
    if (index < fileUrls.length) {
      downLoadFile(fileUrls[index]);
      index++;
      setTimeout(downloadNext, 500); // 延迟1秒后执行下一个下载
    }
  };
  downloadNext();
};

/**
 * Ras加密函数
 * @param params 需要加密的参数
 * @return  params 返回一个新的参数
 */
const rasEncrypt = (params: any) => {
  const publicKeyBase64 =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDGxlGv1TLH/xWkW6HZcTuowJqUHGjYpDcMsURmEAxn0MtaObpfXKfqK/y0HSMNww3EXCCmBdtD3hQ4Gjfkx5X35PRBEIAgymoJaoLMj6YTsEDLnHyDraBOJJlVeJRQVMAmo9MdO5vtSshoZnDph6Azn2aJKabBtKEc1I2TCUexUwIDAQAB";
  encryptor.setPublicKey(publicKeyBase64);
  return encryptor.encrypt(cloneDeep(params));
};
// 保存密码用到的加密函数
const encrypt = (params: any) => {
  const publicKeyBase64 =
    "MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDJ3Yv2p3I2SXSNmuSj0gUckZjj6WVbVxY7QM9XUmxq6HPq3Pbwg2jS0hL5XNdsrNAsAc+KDUGIbqYkAXBcdBYUil1Z79MJDZ/fqW4vUNVNwsZC/13AqjtTd3lBBrZC6XiSW8XQSZqnrkDA4pQGhBhMMQ/qTzRYWZgNi4Wx0icwpwIDAQAB";
  encryptor.setPublicKey(publicKeyBase64);
  return encryptor.encrypt(cloneDeep(params));
};
// 保存密码用到的解密函数
const decrypt = (params: any) => {
  const privateKey =
    "MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAMndi/ancjZJdI2a5KPSBRyRmOPpZVtXFjtAz1dSbGroc+rc9vCDaNLSEvlc12ys0CwBz4oNQYhupiQBcFx0FhSKXVnv0wkNn9+pbi9Q1U3CxkL/XcCqO1N3eUEGtkLpeJJbxdBJmqeuQMDilAaEGEwxD+pPNFhZmA2LhbHSJzCnAgMBAAECgYEAwGjGlvTl3S7IxIyGMEvoCWISC/MUZCqvCw1sVDxBEOm+S3gQfBGVYZVQ9pRy1agmyDt1mY2nECb/f0RL2CPiQkALqjIB/JEOpwUAiZdLQ2E22w7DxFz9iqY0sLlI7ByAr+5/HMP7Ss/K5d8y35xL4yoCRjqSIMORtav3nHmEqrkCQQD81Od5zmPm+lN/kKdT6nsYIjgzPSxr2rGS2VGOoHRHtdgkiZK2hUmZ+vaX7Ke5KKcYKQwTvVPCpM/4rFMX+scFAkEAzGUj9C3rYpbw+9+cUuB59KxT2lDZz5zZIylNVFWRoQP/QK987oikORd6bRusQFzkUfAy2g/46kvyyZ2lSwGQuwJALiDV/rY2Ke0gENUegkP0o2mS4V5W3XKwFT/LDn+d13uI7Nmgx+Y3kH1mQj+uNi0Bl3ndtzhCsO+K9i7Sljxt1QJBAJCeFzxTqTJOnh94bcDt9xw5OfNENXiB/9izBnXfPXTxwQ7hm8GiiJ+kjwjYBZ5cm2emTjSgDHyqVBR3KFbTurUCQQD8gCU9aWmzwuK4YmxAk+Kgo4GLCeNtKZCuBRW8UJxoLUM3UUZHL6uhoohfZyHlYcEjXdsJOWd3DzdyxxsMpS3W";
  encryptor.setPrivateKey(privateKey);
  return encryptor.decrypt(cloneDeep(params));
};

const getAnthorTop = (selector: any) => {
  let top = 0;
  const scrollTop =
    document.documentElement.scrollTop ||
    window.pageYOffset ||
    document.body.scrollTop;
  if (typeof selector === "number") {
    top = selector - scrollTop;
  } else {
    const anchor = document.querySelector(selector) || { offsetTop: 0 };
    top = anchor.offsetTop - scrollTop - 90;
  }
  return top;
};
// 锚点跳转
const goAnchor = (selector: any, scrollSelector?: any) => {
  const element: any = document.querySelector(
    scrollSelector ? scrollSelector : ".layout-content"
  );
  const top = getAnthorTop(selector);
  element.scrollTo({ top, behavior: "smooth" });
};

function arraysEqual(a, b) {
  if (a === b) return true;
  if (a == null || b == null) return false;
  if (a.length !== b.length) return false;

  for (let i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }
  return true;
}

//常规数组转更多数组
function btnListToMoreList(result, moduleList, btnClick, row, moreBtnNum = 3) {
  let moreResult = [];
  let deepResult = Object.assign([], result);
  let deepModuleList = Object.assign([], moduleList);
  if (result.length == 0 || result.length <= moreBtnNum) {
    return result;
  }
  let moreList = deepModuleList.splice(moreBtnNum, deepModuleList.length);
  moreResult = deepResult.splice(0, moreBtnNum);
  moreResult.push(
    h(
      NDropdown,
      {
        options: moreList.map((item) => {
          return {
            key: item.name,
            label: item.label,
            name: item.name,
            disabled: item.disabled ? true : false,
            icon: () => h(NIcon, { component: item.component }),
          };
        }),
        onSelect: (value) => {
          btnClick({ name: value }, row);
        },
      },
      {
        default: () =>
          h(
            NButton,
            {
              text: true,
              tag: "a",
              title: "更多",
              style: {
                fontSize: "18px",
                marginRight: "18px",
                verticalAlign: "middle",
              },
            },
            {
              default: () =>
                h(
                  NIcon,
                  {
                    color: "#333",
                  },
                  {
                    default: () => h(MoreVertical16Regular),
                  }
                ),
            }
          ),
      }
    )
  );
  return moreResult;
}

/**
 * 拷贝合并器
 */
function mergeAssign(defaultInfo, userInfo) {
  let keyList = Object.keys(defaultInfo);
  keyList.forEach((item) => {
    if (userInfo.hasOwnProperty(item)) {
      if (
        Object.prototype.toString.call(defaultInfo[item]) ==
        Object.prototype.toString.call(userInfo[item])
      ) {
        if (
          Object.prototype.toString.call(defaultInfo[item]).includes("Object")
        ) {
          userInfo[item] = Object.assign(defaultInfo[item], userInfo[item]);
        }
      } else {
        if (
          !Object.prototype.toString.call(defaultInfo[item]).includes("Object")
        ) {
          userInfo[item] = cloneDeep(defaultInfo[item]);
        }
      }
    }
  });
  return userInfo;
}

/**
 * 判断是否修改敏感信息
 * @param oldForm
 * @param newForm
 * @param keyList
 * @return true 等于修改了敏感信息，false反之
 */
function isUpdateSusceptible(oldForm, newForm, keyList) {
  console.log(oldForm, newForm);
  let isUpdate = keyList.findIndex((item) => {
    return (
      oldForm[item]?.length != newForm[item]?.length ||
      !isEqual(oldForm[item], newForm[item])
    );
  });
  return isUpdate != -1;
}
// 复制功能
function handelCopy(val: any, sucTipsText = "复制成功") {
  if (isCopy) {
    clearTimeout(isCopy);
  }
  isCopy = setTimeout(() => {
    navigator.clipboard.writeText(val).then(() => {
      window.$message.success(sucTipsText);
    });
  }, 300);
}

/**
 * 阻塞器 传入时间配合async await 使用
 * @param time 传入的是毫秒数
 */
function sleep(time: number) {
  return new Promise((resolve) => {
    let sleepTime = setTimeout(() => {
      resolve();
      clearTimeout(sleepTime);
    }, time);
  });
}
// 千分位转换
function numberToThousands(num) {
  // 将数字转为字符串并取其小数部分，如果没有则为空字符串
  let cents =
    num.toString().indexOf(".") > -1
      ? num.toString().substr(num.toString().indexOf("."))
      : "";
  cents = cents.length == 2 ? cents + "0" : cents; // 若小数部分只有一位，则补上一个 0
  num = Math.floor(num).toString(); // 去掉小数部分并转成字符串
  if (num.length <= 3) {
    return (num == "" ? "0" : num) + cents; // 处理空字符串和 '.00' 的情形
  }
  let intPart = num.replace(/(\d)(?=(?:\d{3})+$)/g, "$1,"); // 截取整数部分并在其后面添加逗号分隔符
  return intPart + cents; // 连接整数部分和小数部分
}
// 获取文件后缀名
const getFileExtension = (filename) => {
  var parts = filename.split(".");
  if (parts.length > 1) {
    return parts.pop(); // 返回数组中的最后一个元素，即文件后缀名
  }
};
// 获取文件名称，包含后缀
const getExtractFileName = (url) => {
  // 使用 split() 函数分割 URL，并取最后一个部分
  var parts = url.split("/");
  var filenameWithParams = parts[parts.length - 1];

  // 使用 split() 函数提取文件名
  var filenameParts = filenameWithParams.split("?")[0].split("."); // 去除可能存在的查询参数，并分割文件名和后缀
  var name = filenameParts[0]; // 获取文件名
  var extension =
    filenameParts.length > 1 ? filenameParts[filenameParts.length - 1] : ""; // 获取后缀，如果没有后缀则为空字符串

  return [name, extension];
};

const openMaterial = (path) => {
  window.open(path);
};
const emojiRules =
  /(\u00a9|\u00ae|\u203c|\u2049|\u20e3|\u2122|\u2139|[\u2194-\u2199]|[\u21a9-\u21aa]|[\u231a-\u231b]|\u2328|\u23cf|[\u23e9-\u23f3]|[\u23f8-\u23fa]|\u24c2|[\u25aa-\u25ab]|\u25b6|\u25c0|[\u25fb-\u25fe]|[\u2600-\u2604]|\u260e|\u2611|[\u2614-\u2615]|\u2618|\u261d|\u2620|[\u2622-\u2623]|\u2626|\u262a|[\u262e-\u262f]|[\u2638-\u263a]|\u2640|\u2642|[\u2648-\u2653]|[\u265f-\u2660]|\u2663|[\u2665-\u2666]|\u2668|\u267b|[\u267e-\u267f]|[\u2692-\u2697]|\u2699|[\u269b-\u269c]|[\u26a0-\u26a1]|\u26a7|[\u26aa-\u26ab]|[\u26b0-\u26b1]|[\u26bd-\u26be]|[\u26c4-\u26c5]|\u26c8|[\u26ce-\u26cf]|\u26d1|[\u26d3-\u26d4]|[\u26e9-\u26ea]|[\u26f0-\u26f5]|[\u26f7-\u26fa]|\u26fd|\u2702|\u2705|[\u2708-\u270d]|\u270f|\u2712|\u2714|\u2716|\u271d|\u2721|\u2728|[\u2733-\u2734]|\u2744|\u2747|\u274c|\u274e|[\u2753-\u2755]|\u2757|[\u2763-\u2764]|[\u2795-\u2797]|\u27a1|\u27b0|\u27bf|[\u2934-\u2935]|[\u2b05-\u2b07]|[\u2b1b-\u2b1c]|\u2b50|\u2b55|\u3030|\u303d|\u3297|\u3299)|(\ud83c(\udc04|\udccf|[\udd70-\udd71]|[\udd7e-\udd7f]|\udd8e|[\udd91-\udd9a]|[\udde6-\uddff]|[\ude01-\ude02]|\ude1a|\ude2f|[\ude32-\ude3a]|[\ude50-\ude51]|[\udf00-\udf21]|[\udf24-\udf93]|[\udf96-\udf97]|[\udf99-\udf9b]|[\udf9e-\udff0]|[\udff3-\udff5]))|(\ud83d([\udc00-\udcfd]|[\udcff-\udd3d]|[\udd49-\udd4e]|[\udd50-\udd67]|[\udd6f-\udd70]|[\udd73-\udd7a]|\udd87|[\udd8a-\udd8d]|\udd90|[\udd95-\udd96]|[\udda4-\udda5]|\udda8|[\uddb1-\uddb2]|\uddbc|[\uddc2-\uddc4]|[\uddd1-\uddd3]|[\udddc-\uddde]|\udde1|\udde3|\udde8|\uddef|\uddf3|[\uddfa-\ude4f]|[\ude80-\udec5]|[\udecb-\uded2]|[\uded5-\uded7]|[\udedd-\udee5]|\udee9|[\udeeb-\udeec]|\udef0|[\udef3-\udefc]|[\udfe0-\udfeb]))|(\ud83e([\udd0c-\udd3a]|[\udd3c-\udd45]|[\udd47-\uddff]|[\ude70-\ude74]|[\ude78-\ude7c]|[\ude80-\ude86]|[\ude90-\udeac]|[\udeb0-\udeba]|[\udec0-\udec5]|[\uded0-\uded9]|[\udee0-\udee7]))|(\udb40([\udc62-\udc63]|\udc65|\udc67|\udc6c|\udc6e|[\udc73-\udc74]))]/g;
const emailRegExp =
  /^[a-zA-Z0-9][a-zA-Z0-9_\-.]*[a-zA-Z0-9]@[a-zA-Z0-9][a-zA-Z0-9.-]*\.[a-zA-Z]{2,}$/;
// 项目名称 订单名称 特殊字符
const specharsRegExp = /^[^\\\/:*？"<>|、]+$/;
// input 前后去空格
const noSideSpace = (value: string) =>
  !value.startsWith(" ") && !value.endsWith(" ");

// 名称排序
const nameSort = (property: any) => {
  return function (a: any, b: any) {
    var value1 = a[property];
    var value2 = b[property];
    return value1.localeCompare(value2, "zh-CN");
  };
};

/**
 * 最后一位向前进一位
 * @param num
 * @returns
 */
const nextNum = (num: number) => {
  // (10-(num % 10))% 10;
  let newNum = new Big(num);
  let tensNum: any = new Big(10);
  let resNum = tensNum.minus(newNum.mod(10));
  return newNum.plus(resNum.mod(10)).toNumber();
};

const uuid = () => {
  return (
    new Date().getTime().toString(36) +
    "-" +
    Math.random().toString(36).substr(2, 9) +
    "-add"
  );
};

// 限制小数位数
const validateDecimalPlaces = (value: string, maxDecimals: number): boolean => {
  value = value.replace("。", ".");
  const decimalPattern = new RegExp(`^(?:\\d+|\\d+\\.\\d{0,${maxDecimals}})$`);
  return !value || decimalPattern.test(value);
};
export {
  emojiRules,
  downLoadFile,
  DownLoadBlobFile,
  isNullCheck,
  setLocalData,
  getLocalData,
  rasEncrypt,
  encrypt,
  decrypt,
  goAnchor,
  arraysEqual,
  btnListToMoreList,
  isUpdateSusceptible,
  handelCopy,
  mergeAssign,
  sleep,
  numberToThousands,
  downloadFiles,
  openMaterial,
  getFileExtension,
  emailRegExp,
  specharsRegExp,
  noSideSpace,
  getExtractFileName,
  nameSort,
  uuid,
  nextNum,
  validateDecimalPlaces,
  downBlobFile,
  getAsyncReader,
};
